document.addEventListener("DOMContentLoaded", function(){

    let linkList = '';
    let anchors = document.getElementById("anchors");

    let titles = document.querySelectorAll(`
        .content > h1, .content > h2, .content > h3, .content > h4, .content > h5, .content > h6,
        .content h1[id], .content h2[id], .content h3[id], .content h4[id], .content h5[id], .content h6[id]
    `);

    let uniqueTitles = Array.from(new Set(titles));

    if (anchors && uniqueTitles.length > 0) {
        uniqueTitles.forEach((title, index) => {
            let content = title.innerText.replace(/<[^>]+>/g, '');

            let id = title.getAttribute("id") || `section-${index}`;
            title.setAttribute("id", id);

            linkList += `<li><a href="#${id}">${content}</a></li>`;
        });

        anchors.innerHTML = linkList;
    }

});
